import { Typography } from '@mui/material';
import '../styles/SlidePreview.css';
import { TagCloud } from 'react-tagcloud';
import Timer from './Timer';
import { Avatar } from "ds-form";
import MyResponsiveBar from './MyResponsiveBar';
import { MarkdownRenderer } from "ds-form";


const SlidePreview = ({ slideConfiguration, type, results, activeSlide, responseTime, timeIsUp, showResponses, ranking, showRanking, presentedSlideID }) => {
    
    return (
        <div className="slidePreview">
            {(type === 1 || type === 2 || type === 3) &&
                <div className="interactiveSlide">
                    {!showRanking && <div className="question">{slideConfiguration.question}</div>}
                    {slideConfiguration.responseTime && activeSlide && !showRanking &&
                        <Timer responseTime={responseTime} timeIsUp={timeIsUp} showResponses={showResponses} presentedSlideID={presentedSlideID} />
                    }
                    {type === 1 && results &&
                        <TagCloud
                            minSize={50}
                            maxSize={100}
                            tags={results}
                            shuffle={false}
                            randomSeed={true}
                        /> 
                    }
                    {type === 2 && results &&
                        <div className="responsiveBar">
                            <MyResponsiveBar data={results}/>
                        </div>
                    }
                    {type === 3 && results &&
                        <>
                            {!showRanking && 
                                <div className="responsiveBar">
                                    <MyResponsiveBar data={results}/>   
                                </div>
                            }
                            {showRanking && 
                                <div className="rankingContainer">
                                    {ranking.sort((a, b) => {
                                        if (b.goodResponses !== a.goodResponses) {
                                            return b.goodResponses - a.goodResponses;
                                        } else {
                                            return a.timeToRespond - b.timeToRespond;
                                        }
                                    }).slice(0, 10).map((user, index) => (
                                        <div className="rankingPosition" key={user.userID}>
                                            <Avatar user={{ value: user.userLogin, label: user.userLogin }} size={40} />
                                            <Typography variant="h6">{index + 1}. {user.goodResponses} pts</Typography>
                                        </div>
                                    ))
                                    }
                                </div> 
                            }  
                        </>   
                    }
                </div>
            }

            {type === 4 &&
                <div className={slideConfiguration.template === 1 ? "basicTemplate" : `basicTemplate template${slideConfiguration.template - 1}`}>
                    <MarkdownRenderer 
                        value={slideConfiguration.content} 
                        style={{width: '100%', height: '100%'}}
                    />    
                </div> 
            }
        </div>
    )
}

export default SlidePreview;